import PropTypes from 'prop-types';

import { ASC, DESC } from '@/common/constants';

export const ListSortDefaultProps = {
  className: null,
  context: null,
  disabled: false,
  dynamicOptions: [],
  handleSort: () => {},
  isLoading: false,
  showNetPrice: false,
  staticOptions: [],
};

export const ListSortPropTypes = {
  className: PropTypes.string,
  context: PropTypes.string,
  disabled: PropTypes.bool,
  dynamicOptions: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      code: PropTypes.string,
      direction: PropTypes.oneOf([ASC, DESC]),
      directions: PropTypes.arrayOf(PropTypes.oneOf([ASC, DESC])),
      label: PropTypes.string,
    }),
  ),
  handleSort: PropTypes.func,
  isLoading: PropTypes.bool,
  showNetPrice: PropTypes.bool,
  staticOptions: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      direction: PropTypes.oneOf([ASC, DESC]),
      label: PropTypes.string,
      sortable: PropTypes.bool,
    }),
  ),
};
